import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, BadgeCheck, Sparkles } from "lucide-react";
import MarketingLayout from "../../components/MarketingLayout";
import CleaningScope from "../../components/CleaningScope";

/**
 * "Tudo incluído na limpeza" — public page that mirrors the exact employee
 * checklist (CleaningScope) so a prospective client can see precisely
 * which tasks the team executes on every single cleaning. There are NO
 * pricing tiers here on purpose — the user wants the page focused only
 * on transparency about what's done.
 */
export default function Oferta() {
  return (
    <MarketingLayout>
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <span className="inline-block text-xs uppercase tracking-[0.22em] text-[#d4af37]"
              data-testid="oferta-eyebrow">
          Transparência total
        </span>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl tracking-tight text-[#fdfbf7] leading-tight"
            data-testid="oferta-headline">
          Tudo o que está <span className="italic text-[#d4af37]">incluído</span> em cada limpeza
        </h1>
        <p className="mt-5 text-lg text-[#a0b2af] max-w-2xl"
           data-testid="oferta-intro">
          Sem letras pequenas. Esta é a checklist profissional que a equipa executa em cada
          serviço — verificada pelo responsável antes de finalizar e validada com relatório
          fotográfico antes/depois.
        </p>

        {/* Trust badges */}
        <div className="mt-7 flex flex-wrap items-center gap-3 text-xs"
             data-testid="oferta-trust-badges">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#062c27] border border-[#d4af37]/35 text-[#fdfbf7]">
            <BadgeCheck size={12} className="text-[#d4af37]" /> Equipa fixa fardada
          </span>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#062c27] border border-[#d4af37]/35 text-[#fdfbf7]">
            <ShieldCheck size={12} className="text-[#d4af37]" /> Verificação obrigatória
          </span>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#062c27] border border-[#d4af37]/35 text-[#fdfbf7]">
            <Sparkles size={12} className="text-[#d4af37]" /> Relatório fotográfico
          </span>
        </div>

        {/* The checklist itself — same component the cleaning crew uses */}
        <div className="mt-10">
          <CleaningScope testId="oferta-cleaning-scope" />
        </div>

        {/* CTA */}
        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <Link to="/#contacto"
                className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-sm text-sm sm:text-base font-semibold uppercase tracking-widest text-[#031411] bg-[#d4af37] hover:bg-[#f5d76e] shadow-lg shadow-[#d4af37]/20 transition-colors focus:outline-none focus:ring-2 focus:ring-[#d4af37]"
                data-testid="oferta-cta">
            Pedir orçamento gratuito <ArrowRight size={18} />
          </Link>
          <p className="text-xs sm:text-sm text-[#a0b2af]">
            Resposta em menos de 24h · Sem fidelização · Sem mensalidades
          </p>
        </div>
      </section>
    </MarketingLayout>
  );
}
